import React, { useState, useEffect } from "react";
import CollapseContent from "../profile/CollapseContent";
import { Row, Col } from "antd";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import AddDonateToOrphansRequest from "./AddDonateOrphansModal";
import CustomConfigProvider from "../../ProfileHeader";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import { getSponsoredOrphans } from "../../../../apis/actions/sponsor.actions";
interface ContentProfileProps {
  data: any;
}

export const MySponsorships = ({ data }: ContentProfileProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const [filteredTabs, setFilteredTabs] = useState<any[]>([]);
  const [state, setState] = useState({
    year: "",
    month: "",
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { sponsoredOrphans } = useSelector((state: RootState) => state.sponsor);
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);
  useEffect(() => {
    dispatch(getSponsoredOrphans({ sponsor_id: OtpId }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const filterBenificiaryTabs = () => {
    const mainOrphans = sponsoredOrphans.filter(
      (orph: any) =>
        orph.sponsorship_type === "main" ||
        orph.sponsorship_type === "main_support"
    );
    const supportOrphans = sponsoredOrphans.filter(
      (orph: any) =>
        orph.sponsorship_type === "support" ||
        orph.sponsorship_type === "main_support"
    );
    const widowOrphans = sponsoredOrphans.filter(
      (orph: any) => orph.sponsorship_type === "widow"
    );
    const tabs = [
      { label: "كفالة رئيسية", array: mainOrphans },
      { label: "كفالة دعم", array: supportOrphans },
      { label: "كفالة أرملة", array: widowOrphans },
    ].filter((tab) => tab.array?.length > 0);

    let filtered = tabs;

    if (state.year || state.month) {
      const stateDate = new Date(Number(state.year), Number(state.month), 1);

      filtered = filtered.map((tab) => ({
        ...tab,
        array: tab.array.filter((item: any) => {
          const itemDate = new Date(item.sponsorship_paid_to);
          return stateDate ? itemDate >= stateDate : true;
        }),
      }));
    }

    setFilteredTabs(filtered);
  };

  useEffect(() => {
    filterBenificiaryTabs();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, data]);

  const benificiaryTabs = filteredTabs;

  return (
    <>
      <CustomConfigProvider
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
        title="كفالاتي"
        dateTitle="مدفوعة إلى"
        fitlerdatewithTitle={true}
        bottomMargin={1.5}
      />

      <Row>
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={6}
          sm={24}
          xs={24}
          style={{ marginLeft: "5px", marginRight: "5px" }}
        >
          <PrimaryButton
            title="التبرع بمبلغ إضافي للأيتام"
            className="takaful--add-request-btn"
            onClick={() => setIsModalVisible(true)}
          />
        </Col>
      </Row>
      <Row gutter={[16, 48]} style={{ marginTop: "2rem" }}>
        <div className="takaful--content-profile">
          <div className="takaful--content-profile-info">
            <CollapseContent data={data} tabsData={benificiaryTabs} />
          </div>
        </div>
      </Row>

      <AddDonateToOrphansRequest
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
    </>
  );
};
